import * as React from 'react';

import {PopoverInfo} from 'shells/popover-info/popover-info';
import {UppercaseLabel} from 'shells/typography/uppercase-label';

import type {
    SmsEditionEngagementStatsFragment as SmsEditionEngagementStats,
    SmsDripSequenceFragment_engagementStats as SmsDripSequenceEngagementStats,
} from 'nutshell-graphql-types';

import {EngagementStatsBlock} from './engagement-stats-block';

type Props = {
    engagementStats: SmsEditionEngagementStats | SmsDripSequenceEngagementStats | null | undefined;
    label?: string;
    isLoading: boolean;
    infoText?: string;
    onClickStat?: (filterKey: string) => string;
};

export function EngagementBar(props: Props) {
    return (
        <div>
            <div className='mb-8'>
                <div className='flex align-center'>
                    <UppercaseLabel>{props.label || 'Totals'}</UppercaseLabel>
                    {props.infoText ? (
                        <PopoverInfo size={14} bodyColor='dark' info={props.infoText} />
                    ) : undefined}
                </div>
            </div>
            <EngagementStatsBlock
                stats={props.engagementStats}
                includeHelp={true}
                onClickStat={props.onClickStat}
                isLoading={props.isLoading}
            />
        </div>
    );
}
